import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import TheHeader from "../comm/inCar/TheHeader";
import {
  CButton,
  CCol,
  CCardBody,
  CFormGroup,
  CContainer,
} from "@coreui/react";
import TheNav from "../comm/inCar/TheNav";
import TheFooter from "../comm/inCar/TheFooter";
import ApoCntrFormPop from "./apoCntrFormPop";
import ApiHelper from "src/utils/api/api_helper";
import Swal from "sweetalert";
import { setApoCntrHdwtInfo, setApoCntrHdwtData } from "src/modules/apoCntrForm";
import { useHistory, useLocation } from "react-router-dom";
import { setReqTaskInfo } from "src/modules/insert";

const ApoCntrFormPage = () => {
  const { apoCntrForm, insert, main } = useSelector((state) => state);
  const dispatch = useDispatch();
  const history = useHistory();
  const corpNm = useLocation().pathname.split('/')[1];
  const pathParam = Number(useLocation().pathname.split('/')[2]);
  const [cntrFormItms, setCntrFormItms] = React.useState([]);
  const [apoCntrRegPop, setApoCntrRegPop] = React.useState({
    isOpen: false,
    itmCd: "",
  });

  const onRegPopClose = () => {
    setApoCntrRegPop({ isOpen: false, itmCd: "" });
    document.getElementsByTagName("body")[0].style.overflow = "scroll";
  };

  const onRegistryClick = (e) => {
    setApoCntrRegPop({ isOpen: true, itmCd: e.target.value });
  };

  const handleHdwtForApoCntrSave = (e, nextPage) => {
    let params = {};
    let data = [];

    for (let item of apoCntrForm.apoCntrHdwtInfo) {
      if (item.update) {
        data.push({ hdwtCatCd: item.hdwtCatCd, imgData: item.data });
      }
    }

    params.reqNo = insert.reqTaskInfo.reqNo;
    params.data = JSON.stringify(data);

    if (nextPage) {
      for (let checkForm of apoCntrForm.apoCntrHdwtInfo) { 
        if (!checkForm.data)
          return Swal(
            "서류작성",
            "모든 서류를 확인하시고, 서명을 하셔야 다음으로 이동이 가능합니다.",
            "error"
          );
        //}
      }
    }

    ApiHelper.request(
      ApiHelper.methods.post,
      "/cust/request/tempSaveStep4And5",
      params
    ).then(({ data }) => {
        if (data.status === "SUCCESS") {
          if (nextPage) {
            history.push(`/${corpNm}/${pathParam + 1}`);
          } else {
            return Swal("", "임시저장 되었습니다.", "success");
          }
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getInitData = async () => {
    let params = {};

    params.corpNo = main.corpNo;
    params.taskNo = main.taskNo;
    
    await ApiHelper.request(
      ApiHelper.methods.get,
      "/cust/request/cntrFormItms",
      params
    )
    .then(({ data }) => {
      if (data.status === "SUCCESS") {
        let result = data.data;
        
        setCntrFormItms(result.itm);
        
        if (apoCntrForm.isFirst) {
          dispatch(setApoCntrHdwtInfo(result.hdwt));
        }
      }
    })
    .catch((err) => {
      console.error(err);
    });
  };

  React.useEffect(async () => {
    await getInitData();

    if (apoCntrForm.isFirst) {
      ApiHelper.request(ApiHelper.methods.post, "/cust/request/hdwtInfo1", {
        reqNo: insert.reqTaskInfo.reqNo,
      })
        .then(({ data }) => {
          if (data.status === "SUCCESS") {
            let result = data.data;
            dispatch(setApoCntrHdwtData(result, true));
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, []);

  return (
    <>
      <TheHeader />
      <div className="c-main">
      <TheNav step={main.step} />
        <CContainer className="text-left">
          <h5>
            <b>정보제공 동의서를 작성합니다.</b>
          </h5>
        </CContainer>
        <CCardBody className="bottom-card-body">
          { cntrFormItms.length > 0
            &&
            cntrFormItms.map((item) => {
              let hdwtData = item.HDWT_CAT_CD.split(',');
              let checkYn = true;

              if(hdwtData.length > 0 && apoCntrForm.apoCntrHdwtInfo.length > 0) {
                for(let i = 0; i < hdwtData.length; i++) {
                  checkYn = checkYn && (apoCntrForm.apoCntrHdwtInfo.filter((item) => item.hdwtCatCd === hdwtData[i])[0].data ? true : false);                                   
                }
              }

              return (
                <CFormGroup row className="mb-3 formCheckbox" key={item.ITM_CD}>
                  <CCol xs="2">
                  <label className="component-checkbox">
                      <input 
                        type="checkbox" 
                        id={item.ITM_CD}
                        name={item.ITM_CD}
                        value={item.ITM_CD}
                        onClick={onRegistryClick}
                        readOnly
                        checked={checkYn}
                      />
                      <i />
                    </label>
                  </CCol>
                  <CCol xs="10">
                    <CButton
                      className={ checkYn
                          ? 'isChecked'
                          : undefined }
                      color="primary"
                      variant="outline"
                      value={item.ITM_CD}
                      block
                      onClick={onRegistryClick}
                    >
                      {item.ITM_NM}
                    </CButton>
                  </CCol>
                </CFormGroup>
              )
            })
          }         
        </CCardBody>
      </div>
      <TheFooter
        step={main.step}
        handleHdwtForApoCntrSave={handleHdwtForApoCntrSave}
      />
      {apoCntrRegPop.isOpen && (
        <ApoCntrFormPop
          modal={true}
          itmCd={apoCntrRegPop.itmCd}
          onClose={onRegPopClose}
        ></ApoCntrFormPop>
      )}
    </>
  );
};

export default ApoCntrFormPage;
